import {
  SET_INFORMATION_SNACKBAR_STATE, SET_INFORMATION_SNACKBAR_TEXT,
  SET_INFORMATION_DISPLAYED_LIST, SET_INFORMATION_TOASTER_STATE, SET_INFORMATION_TOASTER_TEXT
} from '../mutation-types'
import {FROM_INTERACTIONS_LIST} from '../getter-types'

export const informationTexts = {
  INTERVENTION_CREATED: 'intervention_created',
  GROUP_INTERVENTION_CREATED: 'group_intervention_created',
  GROUP_EXEMPTION_CREATED: 'group_exemption_created',
  FORBIDDEN_RESOURCE: 'forbidden_resource_snackbar',
  INTERVENTION_UPDATED: 'intervention_updated',
  ALERT_EMAIL_SAVED: 'admin.alerts.email.saved',
  ALERTS_COURSE_UPDATED: 'admin.alerts.course_selection.updated',
  EXEMPTION_CREATED: 'exemption.created',
  EXEMPTION_UPDATED: 'exemption.updated',
  EXEMPTION_DELETED: 'exemption.deleted',
  FEED_STARTED: 'feeds.in_progress',
  FEED_ALREADY_RUNNING: 'feeds.blocked',
  FEED_UNABLE: 'feeds.unable',
  ANNOUNCEMENT_UPDATED: 'announcements.admin.information.updated',
  ANNOUNCEMENT_CREATED: 'announcements.admin.information.created',
  ANNOUNCEMENT_STATUS_UPDATED: 'announcements.admin.information.status',
  SAVE_FILTER_CANCEL: 'save_filter_cancelled',
  SAVE_FILTER_CREATED: 'save_filter_created',
  CHART_CREATED: 'dashboard.chart_created',
  CREATE_CHART_FILTER_CANCELLED: 'dashboard.chart.filter_cancelled',
  CHART_FILTER_UPDATED: 'dashboard.chart.filter_updated',
  CHART_UPDATED_WITH_NEW_FILTER: 'dashboard.chart.new_filter_updated',
  CHART_REORDER_APPLIED: 'dashboard.chart.reorder_applied',
  CHART_REORDER_CANCELLED: 'dashboard.chart.reorder_cancelled',
  ALERT_ACTIVATED: 'admin.alerts.new.activated',
  ALERT_DEACTIVATED: 'admin.alerts.new.deactivated',
  COPY_TO_CLIPBOARD: 'admin.alerts.new.placeholders.clipboard_copy',
  SUBMITTED_DATA_SET: 'admin.alerts.new.data_sets.submitted',
  ALERT_CREATED: 'admin.alerts.new.created',
  ALERT_COPIED: 'admin.alerts.new.copied',
  ALERT_UPDATED: 'admin.alerts.new.updated',
  SUBMITTED_EMAIL_TEMPLATE: 'admin.alerts.new.email_templates.submitted',
  FEED_ACTIVATED: 'feeds.activated',
  FEED_DEACTIVATED: 'feeds.deactivated',
  FEED_RUN_CANCEL: 'feeds.feed_run_cancelled',
  GROUP_CREATED: 'group_created',
  GROUP_UPDATED: 'group_updated',
  GROUP_DELETED: 'group_deleted',
  GROUP_STUDENTS_ADDED: 'group_students_added',
  GROUP_SELECTED: 'group_selected',
  GROUP_STUDENTS_EXISTED: 'group_students_existed',
  DATA_PURGE_STARTED: 'data_purge.started',
  DATA_PURGE_RESET: 'data_purge.reset',
  CATEGORY_CREATED: 'config.category_created',
  CATEGORY_UPDATED: 'config.category_updated',
  REFERRAL_UPDATED: 'intervention_referral_snackbar_message_update',
  CUSTOM_TEXT_UPDATED: 'custom_text_message_update',
  REFERRAL_CREATED: 'intervention_referral_snackbar_message_create',
  ENROLMENT_STATUS_CREATED: 'enrolment_status_snackbar_message_create',
  ENROLMENT_STATUS_UPDATED: 'enrolment_status_snackbar_message_update',
  EMAIL_TEMPLATE_UPDATED: 'email_template_customization.email_template_updated',
  EMAIL_TEMPLATE_DELETED: 'email_template_customization.email_template_deleted',
  EMAIL_TEMPLATE_CREATED: 'email_template_customization.email_template_created',
  LOGIN_SUCCESS: 'login.message',
  HELP_TOPIC_ARTICLE_CREATED: 'help-topic.article-created',
  HELP_TOPIC_ARTICLE_DELETED: 'help-topic.article-deleted',
  HELP_TOPIC_ARTICLE_UPDATED: 'help-topic.article-updated',
  HELP_TOPIC_ARTICLE_ORDER_UPDATED: 'help-topic.article-order-updated'
}

export const listNames = {
  MY_STUDENTS: 'MY_STUDENTS',
  INTERACTIONS: 'INTERACTIONS'
}

const state = {
  snackbar: false,
  snackbarText: informationTexts.INTERVENTION_CREATED,
  toaster: false,
  toasterText: '',
  listName: ''
}

const mutations = {
  [SET_INFORMATION_SNACKBAR_STATE] (state, value) {
    state.snackbar = value
  },
  [SET_INFORMATION_SNACKBAR_TEXT] (state, value) {
    state.snackbarText = value
  },
  [SET_INFORMATION_TOASTER_STATE] (state, value) {
    state.toaster = value
  },
  [SET_INFORMATION_TOASTER_TEXT] (state, value) {
    state.toasterText = value
  },
  [SET_INFORMATION_DISPLAYED_LIST] (state, listName) {
    state.listName = listName
  }
}

const getters = {
  [FROM_INTERACTIONS_LIST]: (state) => {
    return state.listName === listNames.INTERACTIONS
  }
}

export default {
  state,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/information.js